import {getSelectedGroupId} from '../team/teamSelectors';

export const getLogoUrls = (state) => {
  const selectedGroupId = getSelectedGroupId(state);

  const allGroupBranding = state.settings.get('groupBranding').toJS();
  const selectedGroupBranding = allGroupBranding[selectedGroupId];
  const customerBranding = state.settings.get('customerBranding').toJS();

  const logoUrl =
    selectedGroupBranding?.logoUrl ||
    customerBranding?.customerBrandingData?.logoUrl;

  const darkLogoUrl =
    selectedGroupBranding?.darkLogoUrl ||
    customerBranding?.customerBrandingData?.darkLogoUrl;

  return {logoUrl, darkLogoUrl};
};
